// Central index for all English translations

import { authTranslations } from './auth.en'
import { commonTranslations } from './common'
import { errorTranslations } from './errors'
import { formTranslations } from './forms'
import { protocolTranslations } from './protocol'

export const enTranslations = {
  // Merge all translation modules
  ...authTranslations,
  ...errorTranslations,
  ...formTranslations,
  ...commonTranslations,
  ...protocolTranslations,
}
